export default __webpack_public_path__ + "static/media/account_box-24px (1).4865dd25.svg";